import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import { CountNumberOfPositionsBOMPipe } from './count-number-of-positions-bom.pipe';
import { CanTransferToWholesalerPipe } from './can-transfer-to-wholesaler.pipe';

@Pipe({
    name: 'numberOfProjectBomPositions',
    standalone: false
})
export class NumberOfProjectBomPositionsPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            bomModelsAccessories: IBomModel[],
            selectedItems: number[],
            selectedItemsAccessories: number[],
            bomProjectAccessories: IBomModel[],
            selectedProjectAccessories: number[],
            selectedEnclosures: number[]): number {

    return new CountNumberOfPositionsBOMPipe().transform(
      selectedItems,
      new CanTransferToWholesalerPipe().transform(bomModels),
      new CanTransferToWholesalerPipe().transform(bomModelsAccessories),
      selectedItemsAccessories,
      new CanTransferToWholesalerPipe().transform(bomProjectAccessories),
      selectedProjectAccessories,
      selectedEnclosures
    )
  }
}
